//local imports
import classes from "@/styles/fulfilment-partners/fulfilment-partner-header.module.css";
import Image from "next/image";

export default function FulfilmentPartnerHeader({
  title,
  headerImage,
  height,
  width,
}: any) {
  return (
    <div className={classes.container}>
      <div className={`container ${classes.grid}`}>
        <h1 className={classes.heading}>{title}</h1>
        <Image
          className={classes.img}
          src={headerImage}
          alt={headerImage}
          height={height}
          width={width}
        />
      </div>
    </div>
  );
}
